import { useAtom } from "jotai";
import { useEffect } from "react";

import { LoadingSpinner } from "../shared/components/loading-spinner/loading-spinner.component";

import { LanderQuizFooter } from "./components/lander-quiz-footer/lander-quiz-footer.component";
import { LanderQuizHeader } from "./components/lander-quiz-header/lander-quiz-header.component";
import { ButtonsQuestion } from "./components/questions/buttons-question/buttons-question.component";
import { InputQuestion } from "./components/questions/input-question/input-question.component";
import { SelectorQuestion } from "./components/questions/selector-question/selector-question.component";
import { SmsQuestion } from "./components/questions/sms-question/sms-question.component";
import {
  currentQuestionIndexAtom,
  landerQuizFinishedAtom,
  landerQuizQuestionAtom,
  showLoadingSpinnerAtom,
} from "./lander-quiz.state";
import { LanderQuizQuestionTypeEnum } from "./lander-quiz.types";

export function Widget() {
  const [landerQuizFinished] = useAtom(landerQuizFinishedAtom);
  const [currentQuestionIndex] = useAtom(currentQuestionIndexAtom);
  const [currentQuestion] = useAtom(
    landerQuizQuestionAtom(currentQuestionIndex)
  );
  const [showLoadingSpinner] = useAtom(showLoadingSpinnerAtom);

  useEffect(() => {
    landerQuizFinished &&
      window.theme.LanderQuizUtils.handleNextSweepFlowStep();
  }, [landerQuizFinished]);

  return (
    <div className="demographic-quiz">
      {landerQuizFinished || showLoadingSpinner
        ? LoadingSpinner
        : (
          <>
            <LanderQuizHeader />
            {currentQuestion.type === LanderQuizQuestionTypeEnum.FreeInput ||
              currentQuestion.type ===
              LanderQuizQuestionTypeEnum.FreeInputAddress ? (
              <InputQuestion />
            ) : currentQuestion.type === LanderQuizQuestionTypeEnum.DropDown ? (
              <SelectorQuestion />
            ) : currentQuestion.type === LanderQuizQuestionTypeEnum.Sms ? (
              <SmsQuestion />
            ) : (
              <ButtonsQuestion />
            )}
            <LanderQuizFooter />
          </>
        )}
    </div>
  );
}
